import { render, staticRenderFns } from "./LandmarkCard.vue?vue&type=template&id=ef3fa782&"
import script from "./LandmarkCard.vue?vue&type=script&lang=js&"
export * from "./LandmarkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports